import { convertDigitToProperFormat } from 'utils/number';

export default {
  validFormats: 'فرمت‌های مجاز: ',
  maxSizeOfUpload: 'بیشترین حجم مجاز: ',
  getMB(size: number) {
    return `${convertDigitToProperFormat(size)} مگابایت`;
  },
  getKB(size: number) {
    return `${convertDigitToProperFormat(size)} کیلوبایت`;
  },
};

export const definedTypes: { [type: string]: string } = {
  audio: 'فایل صوتی',
  video: 'فیلم',
  image: 'عکس',
  document: 'اسناد',
  compressed: 'فایل فشرده',
};
